<template>
  <div class="idx_wrapper">
    <div class="footer_wrap">
      <div class="w_1200">
<!--
        <div class="f_l">
           <a  href="http://bszs.conac.cn/sitename?method=show&id=09C03AB26B2343F6E053012819AC4989" target="_blank">
          <img :src="require('@/assets/newStyle/images/f_dzjg_img.png')" />
          </a>
        </div>
        -->
        <div class="f_m" style="width: 100%">
          <p>主办单位：信阳市政务大数据中心</p>
          <p>建议使用IE10及以上版本或Chrome、360等主流浏览器访问本网站</p>
        </div>
<!--        <a href="https://zfwzgl.www.gov.cn/exposure/jiucuo.html?site_code=4115000002&url=https%3A%2F%2Fwww.xinyang.gov" target="_blank" class="f_r"><img :src="require('@/assets/newStyle/images/f_zc_img.png')" /></a>-->
      </div>
    </div>
    <div class="class_dia">
      <el-dialog
        title="欢迎登陆信阳市免审即享企业服务平台"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="35%"
        center
      >
        <div class="dialogCon">
          <div style="margin: 1.25rem 0; display: flex; align-items: center">
            <span>当前企业信息完成度：</span>
            <el-progress
              style="width: 200px"
              :text-inside="true"
              :stroke-width="22"
              :percentage="enterpriseBaseinfo.completion"
            ></el-progress>
          </div>
          <!-- <span>请选择是否完善企业信息！</span> -->
          <div class="chooseBtn">
            <!-- <span class="item">当前为您推送了：</span> -->
            <span class="item2"
            >已兑现政策：<span class="num">{{ policyInfo.policyNum }}条</span></span
            >
            <span class="item2"
            >可兑现政策：<span class="num"
            >{{ policyInfo.projectNum }}条</span
            ></span
            >
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="closeT"
            style="
              height: 40px;
              width: 120px;
              color: #fff;
            "
          >取 消</el-button
          >
          <el-button
            type="primary"
            @click="toRelevantPage('userCenter')"
            style="height: 40px; width: 120px; margin-left: 20px"
          >去完善信息</el-button
          >
          <el-button
            type="primary"
            @click="toRelevantPage('policyPush')"
            style="height: 40px; width: 120px; margin-left: 20px"
          >去免申即享</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      dialogVisible: false,
      visitNum: 0,
      enterpriseBaseinfo: {},
      policyInfo: {
        policyNum: 0,
        projectNum: 0,
      },
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
    }),
  },
  created() {
    this.addNum();
    this.getNum();
    this.getPolicyInfoNum();
    this.openDialog();
  },
  methods: {
    getPolicyInfoNum() {
      let url = "/dev-api/sqPolicyPush/push/selectPushPolicysNum";
      let params = {
        shxydm: this.userInfo.tyshxydm,
      };
      this.$httpApi
        .post(url, params)
        .then((res) => {
          if (res.code == 200) {
            this.policyInfo.policyNum = res.data.policyNum;
            this.policyInfo.projectNum = res.data.policyItemNum;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    openDialog() {
      let isFirst = sessionStorage.getItem("isFirst");
      if (isFirst == "true") {
        this.getInfoByShxydm();
        this.dialogVisible = true;
        sessionStorage.setItem("isFirst", "false");
      } else {
        this.dialogVisible = false;
      }
    },
    setCompletionByShxydm() {
      let url = "/dev-api/enterprise/baseInfo/setCompletionByShxydm";
      if (this.enterpriseBaseinfo.completion == "0") {
        this.$httpApi
          .get(url, { shxydm: this.userInfo.tyshxydm })
          .then((res) => {
            if (res.code == "200") {
              this.enterpriseBaseinfo.completion = res.msg;
            }
          });
      }
    },
    getInfoByShxydm() {
      let url = "/dev-api/enterprise/baseInfo/getInfoByShxydm";
      this.$httpApi.get(url, { shxydm: this.userInfo.tyshxydm }).then((res) => {
        if (res.code == "200") {
          this.enterpriseBaseinfo = res.data;
          this.setCompletionByShxydm();
        }
      });
    },
    toRelevantPage(param) {
      this.dialogVisible = false;
      let url =
        param == "userCenter" ? "/workplace/setting" : "/enjoyWithoutApply/viewEnjoyPage";
      this.$router.push(url);
    },
    closeT() {
      this.dialogVisible = false;
    },
    addNum() {
      let url = "/dev-api/times/addOrUpdateSysIpTimes";
      let ip = document.domain;
      let params = {
        ip,
      };
      this.$httpApi.post(url, params).then((r) => {});
    },
    getNum() {
      let url = "/dev-api/times/countSysIpTimes";
      let params = {};
      this.$httpApi
        .post(url, params)
        .then((r) => {
          this.visitNum = r.data;
        })
        .catch((e) => {});
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/newStyle/css/idx.scss";
@import "@/assets/newStyle/css/login.scss";
@import "@/styles/index20220105.scss";
.footer-container {
  position: relative;
  // margin-top: 50px;
  width: 100%;
  // height: $footerHeight;
  min-height: 54px;
  font-size: 16px;
  background-color: #eaebeb;
  .footer-left {
    padding-top: 10px;
  }
  span + span {
    // margin-left: 100px;
    margin: 5px 0;
  }
}
.wrap_inner {
  height: 100%;
}
.class_dia {
  font-size: 18px;
  font-weight: 600;
  .dialogCon {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .chooseBtn {
    display: flex;
    justify-content: flex-start;
    .item {
      margin-right: 20px;
    }
    .item2 {
      margin-right: 40px;
    }
    .num {
      color: #409eff;
    }
  }
}
</style>
